<script>
import Vuescroll from 'vuescroll';

export default {
  components: { Vuescroll },
  mounted(){
    this.$store.commit("refs", {
      ...this.$store.get("refs"), 
      page: this.$refs['page'],
      drawer: this.$refs['drawer']
    })
  },
  data() {
    return {
      ops: {
        vuescroll: {
          mode: 'native',
        },
        rail: {
          size: "20px"
        },
        bar: {
          size: "12px",
          background: "#666"
        }
      }
    }
  },
  methods: {
    openDrawer(e){
      if(!this.$store.get("openDrawer")){
        e.stopPropagation()
        this.$store.commit("openDrawer", true);
      }
    },
    toggleDrawer(e){
      e.stopPropagation()
      this.$store.commit("openDrawer", !this.$store.get("openDrawer"));
    },
  }
};
</script>

<template>
  <div class="drawer-area" :class="{'closed': !$store.get('openDrawer')}">
    <div class="drawer" @click="openDrawer">
      <div class="close" @click="toggleDrawer">
        <span v-if="$store.get('openDrawer')" class="fa fa-angle-double-left"></span>
        <span v-else class="fa fa-filter"></span>
      </div>
      <div class="panel">
        <Vuescroll :ops="ops" ref="drawer">
          <slot name="drawer"></slot>
        </Vuescroll>
      </div>
    </div>
    <div id="scroll-page" class="page" ref="page">
      <slot name="page"></slot>
    </div>
  </div>
</template>

<style lang="scss">
@import "~@/styles/constants";
.drawer-area {
  height: 100%;
  display: flex;
  align-items: stretch;
  position: relative;
  &.closed{
    .drawer {
      width: 1.5rem;
      .close{
        left: 0rem;
        &:hover, &.hover{
          // left: 1rem;
        }
      }
      .panel{
        * {
          display: none;
        }
      }
    }
    .page {
      margin-left: 1rem;
    }
  } 
  .drawer {
    width: 29rem;
    height: 100%;
    background-color: $black_3;
    position: absolute;
    top: 0rem;
    left: 0rem;
    z-index: 2;
    .close{
      position: fixed;
      top: 50%;
      left: 27.5rem;
      width: 3rem;
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: $black_3;
      border: 1px solid $black_1; 
      color: $w;
      box-shadow: $z_depth_1;
      font-size: 1.25rem;
      z-index: 100;
      .fa-angle-double-left{
        font-size: 1.5rem;
      }
      &:hover, &.hover{
        cursor: pointer;
        background-color: $black_4;
      }
    }
    .panel{
      height: 100%;
    }
  }
  .page {
    height: 100%;
    margin-left: 29rem;
    flex: 1;
    overflow: auto;
    z-index: 1;
  }
}
</style>